export default "__VITE_ASSET__BQaJ6tcS__"